import { useTranslation } from 'react-i18next';
import { useEditorStore } from '@/store/editorStore';
import { useDocumentStore } from '@/store/documentStore';
import { useIsMobile } from '@/hooks/useMediaQuery';

export function StatusBar() {
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const zoom = useEditorStore((s) => s.zoom);
  const saveStatus = useEditorStore((s) => s.saveStatus);
  const nodes = useDocumentStore((s) => s.nodes);

  const statusLabels: Record<string, string> = {
    saved: t('status.saved'),
    saving: t('status.saving'),
    offline: t('status.offline'),
    error: t('status.saveError'),
  };

  const statusText = statusLabels[saveStatus] ?? saveStatus;

  const statusColor =
    saveStatus === 'error' ? 'var(--color-danger)'
      : saveStatus === 'offline' ? 'var(--color-warning)'
        : saveStatus === 'saving' ? 'var(--text-secondary)'
          : 'var(--color-success)';

  return (
    <div
      style={{
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        display: 'flex',
        alignItems: 'center',
        gap: isMobile ? 8 : 16,
        padding: isMobile ? '2px 8px' : '4px 16px',
        background: 'var(--bg-app)',
        borderTop: '1px solid var(--border-subtle)',
        zIndex: 10,
        fontFamily: 'var(--font-family)',
        fontSize: isMobile ? 10 : 'var(--font-size-xs)',
        color: 'var(--text-tertiary)',
      }}
    >
      <span>{t('status.nodeCount', { count: nodes.size })}</span>
      {!isMobile && <span>{Math.round(zoom * 100)}%</span>}
      <span style={{ color: statusColor }}>{statusText}</span>
    </div>
  );
}
